import React from 'react';
import PropTypes from 'prop-types';
import { Icons, Grid } from '@techsoftware/happay-widgets';

export default function MerchantFormatter(props) {
  const { type, row, data } = props;
  const logo = type === 'merchant' ? row?.gmr?.logo : row?.merchant_logo;
  return (
    <Grid container alignItems="center" className='no-flex-wrap'>
       <div className="img-circle">
        {logo ? (
          <img src={logo} alt="merchant" />
        ) : (
          <Icons type="allmerchants" size="mini" />
        )}

       </div>
      <div className="merchant-div">{data}</div>
    </Grid>
    //     <div className="img-circle">
    //     {row.merchant_logo && row.merchant_logo ? (
    //       <img src={row.merchant_logo} alt="merchant" />
    //     ) : (
    //       <Icons type="allmerchants" size="mini" />
    //     )}
    //     <div className="merchant-div">{data}</div>
    //   </div>
  );
}
MerchantFormatter.propTypes = {
  type: PropTypes.string,
  data: PropTypes.string,
  row: PropTypes.object,
};
MerchantFormatter.defaultProps = {
  type: '',
  data: '',
  row: {},
};
